import { RemoveScrollSideCar as r } from "./index.es501.js";
import { effectCar as o } from "./index.es500.js";
import { exportSidecar as e } from "./index.es450.js";
const f = e(o, r);
export {
  f as default
};
//# sourceMappingURL=index.es478.js.map
